/**
 * Logger utility that only logs in development mode.
 * In production, all logs are silently ignored.
 */

const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  log: (...args) => isDev && console.log(...args),
  info: (...args) => isDev && console.info(...args),
  warn: (...args) => isDev && console.warn(...args),
  error: (...args) => console.error(...args), // Always log errors
  debug: (...args) => isDev && console.debug(...args),
};

export default logger;
